import { render } from "./TypeIcon.vue?vue&type=template&id=6f86a3c4"
import script from "./TypeIcon.vue?vue&type=script&lang=js"
export * from "./TypeIcon.vue?vue&type=script&lang=js"

import "./TypeIcon.vue?vue&type=style&index=0&id=6f86a3c4&lang=scss"

import exportComponent from "/app/tmp/360pt/V3/v2026.6.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__